import { IUser, IUserUpdate } from '../../store/modules/UserModule';
import ApiService from './base/ApiService';

export default class UserService extends ApiService<IUser, IUserUpdate> {
  constructor() {
    super('user');
  }
}
